import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyAssignedAe = createSelector(
  selectSubCompany,
  subCompany => subCompany?.assignedAe ?? null,
);
